import "./index.css";
import Intro from "./Components/Intro";

const App = () => {


  return (
    <div className={`w-full  snap-y snap-mandatory min-h-screen`}>
      <Intro />
    </div >
  );
};

export default App;
